import axios from "axios";

let hasSessionExpired = false;

const instance = axios.create({
  baseURL:
    process.env.NODE_ENV === "development" ? "http://localhost:3000" : "",
});

instance.interceptors.request.use((config: any) => {
  const token = getToken();

  if (token) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = "Bearer " + token;
  }
  return config;
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      error.response.status === 401 &&
      !hasSessionExpired
    ) {
      hasSessionExpired = true;

      // Clear tokens
      localStorage.removeItem("token");
      sessionStorage.removeItem("token");
      localStorage.removeItem("remember_me");

      redirectToLogin();
    }
    return Promise.reject(error);
  }
);

function getToken() {
  const isPersist = localStorage.getItem("remember_me");

  if (isPersist === "true") {
    return localStorage.getItem("token");
  } else {
    return sessionStorage.getItem("token");
  }
}

const redirectToLogin = () => {
  const isProd = process.env.NODE_ENV === "production";

  if (isProd) {
    if (!window.location.hash.includes("#/login")) {
      window.location.href = "/#/login";
    }
  } else {
    if (window.location.pathname !== "/login") {
      window.location.href = "/login";
    }
  }
};

export default instance;
